import { render, staticRenderFns } from "./StudentElectiveCourse.vue?vue&type=template&id=3e98a347"
import script from "./StudentElectiveCourse.vue?vue&type=script&lang=js"
export * from "./StudentElectiveCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports